import simpleParallax from 'simple-parallax-js';

export function parallax() {
  const images = document.querySelectorAll('img.parallax');
  new simpleParallax(images, {
    scale: 1.2,
  });
}
